import { catalogSlice } from "./catalog-slice";
import { reduxFormSlice } from "./redux-form-slice";

export const actionCreators = {
    ...reduxFormSlice.actions,
    ...catalogSlice.actions
};